 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		54: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		54: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~AboutUsPage~AppPage~BrandPage~DoNotSellMyPI~DynamicDiscountBetaPage~DynamicDiscountPage~Ente~13592445","1":"AboutUsPage~AppPage~BrandPage~DoNotSellMyPI~DynamicDiscountBetaPage~DynamicDiscountPage~EnterToWinPa~84a1d14e","2":"vendors~EnterToWinPage~FavoriteStationsListsPage~FavoritesListPage~FuelLogBookPage~FuelLogEntryPage~~297a85c6","3":"vendors~BrandPage~EnterToWinPage~FavoritesListPage~FuelLogBookPage~FuelLogEntryPage~MyVehicleProfile~a3067fe1","4":"vendors~FavoritesListPage~FuelLogBookPage~FuelLogEntryPage~HomePage~PaySavingsPage~RegionalGasPrices~4c44555f","5":"vendors~AboutUsPage~HomePage~LandingPageTemplate1~PressReleasePage~TimelinePage","6":"vendors~HomePage~LandingPageTemplate1~PressReleasePage","7":"vendors~MyVehicleProfilePage~PaySavingsPage~Terms","8":"vendors~BrandPage~RegionalGasPrices","9":"AboutUsPage","10":"AppPage","11":"BrandPage","12":"CMSPage","13":"Disclaimers-Canada","14":"Disclaimers-USA","15":"DoNotSellMyPI","16":"DynamicDiscountBetaPage","17":"DynamicDiscountPage","18":"EnterToWinPage","19":"FavoriteStationsListsPage","20":"FavoritesListPage","21":"FuelLogBookPage","22":"FuelLogEntryPage","23":"GasbackLanding","24":"HomePage","25":"LandingPageTemplate1","26":"LegalPage","27":"MyVehicleProfilePage","28":"MyVehiclesPage","29":"NewsArticlesPage","30":"NewsroomPage","31":"PayPlusPage","32":"PaySavingsPage","33":"PressReleaseLookup","34":"PressReleasePage","35":"PressReleasesPage","36":"PrivacyPolicies-Canada","37":"PrivacyPolicies-USA","38":"ProfilePage","39":"RedirectToFuelLogBook","40":"RegionSelectPage","41":"RegionalGasPrices","42":"SearchResultsPage","43":"ShopYourWayPage","44":"SocialSignup","45":"Station","46":"Terms","47":"TimelinePage","48":"UbiQuote","49":"Unknown","50":"UserEmailPreferencesPage","51":"VehicleRecallSearchPage","52":"VehicleRecallSearchResultsPage","53":"VisitorPreferencesPage","56":"vendors~LandingPageTemplate1","57":"vendors~ProfilePage","58":"vendors~ShopYourWayPage","59":"vendors~SocialSignup","60":"vendors~UserEmailPreferencesPage"}[chunkId]||chunkId) + "." + {"0":"374f1d78540f7a82146c","1":"bdcbe4788bfabf39238b","2":"69b887b06b1fa3d05ac9","3":"8502d0db691895ba2c4f","4":"0037ae774f83a20f2fad","5":"80198f417757bf802adc","6":"a6b4524676c5d6355d9a","7":"0dadf9bddd4ce2f308c0","8":"0752b3fdf662cbae5474","9":"fca30ac45888a2276bc6","10":"86b121ae672cabb92f12","11":"1dda0bf9a84af98dd86f","12":"072eba58db55aa5d5085","13":"8b606daadf57a09bb1d2","14":"f716d9e801cd7c3db26a","15":"4817a4b4d04f1202d048","16":"42a323ee889f93690afd","17":"b6d525f0a29be0fae993","18":"1d692b1511793a140f50","19":"3336819d90aba983e57b","20":"4e0cf87cf4059ee4aa06","21":"6252e7e107a169741c9f","22":"8361e5de97707caf9632","23":"a3170a085d340e368dcc","24":"17f5143de72ee5e8a1d4","25":"f165a63eb9e0f2ff7ec0","26":"110e74740f0dd553047e","27":"8f826d9a0367b19c1f1a","28":"432dc28239ff5d5fd8bf","29":"bd2965d7dfd89ea8916c","30":"0d02667fb721c7a5e1f2","31":"cafa6ed5879a6080f852","32":"d0b054e2457ffce9e945","33":"0772e2ed90671f3c3373","34":"e656d9ef000c42c3a04c","35":"e33ab3df70e308923a41","36":"3af3057e3856c5bc7ed5","37":"461e2084386fa42efb17","38":"789e73d3171266e02901","39":"c80569c242e6a598ac32","40":"09bade26b1bb6da95f2a","41":"a8bb9a5e7b473543ce96","42":"b6551e2bb53c421aa776","43":"920b32205e6fbcc3e6e1","44":"c5841ab162e3f39f2a54","45":"0a5d0c10c938dbaa106a","46":"b2f726d55f785b8e167a","47":"2a77c4d136bb5c7a4027","48":"33e79a0a023671c030c0","49":"eef7efb45e4abcf0630d","50":"af2968d38beb4bcbf3d5","51":"eb38a87d74c1c539a050","52":"e73fd95be8690e3347e7","53":"235d04508e16650b5839","56":"0a3db4022fd9b4159ede","57":"eb489304949cdccb3a90","58":"33a6cee06ebbbd414606","59":"3239b2134e862b734898","60":"6e1579385bc1d2dc158f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"8":1,"9":1,"10":1,"11":1,"12":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"45":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"56":1,"57":1,"58":1,"59":1,"60":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~AboutUsPage~AppPage~BrandPage~DoNotSellMyPI~DynamicDiscountBetaPage~DynamicDiscountPage~Ente~13592445","1":"AboutUsPage~AppPage~BrandPage~DoNotSellMyPI~DynamicDiscountBetaPage~DynamicDiscountPage~EnterToWinPa~84a1d14e","2":"vendors~EnterToWinPage~FavoriteStationsListsPage~FavoritesListPage~FuelLogBookPage~FuelLogEntryPage~~297a85c6","3":"vendors~BrandPage~EnterToWinPage~FavoritesListPage~FuelLogBookPage~FuelLogEntryPage~MyVehicleProfile~a3067fe1","4":"vendors~FavoritesListPage~FuelLogBookPage~FuelLogEntryPage~HomePage~PaySavingsPage~RegionalGasPrices~4c44555f","5":"vendors~AboutUsPage~HomePage~LandingPageTemplate1~PressReleasePage~TimelinePage","6":"vendors~HomePage~LandingPageTemplate1~PressReleasePage","7":"vendors~MyVehicleProfilePage~PaySavingsPage~Terms","8":"vendors~BrandPage~RegionalGasPrices","9":"AboutUsPage","10":"AppPage","11":"BrandPage","12":"CMSPage","13":"Disclaimers-Canada","14":"Disclaimers-USA","15":"DoNotSellMyPI","16":"DynamicDiscountBetaPage","17":"DynamicDiscountPage","18":"EnterToWinPage","19":"FavoriteStationsListsPage","20":"FavoritesListPage","21":"FuelLogBookPage","22":"FuelLogEntryPage","23":"GasbackLanding","24":"HomePage","25":"LandingPageTemplate1","26":"LegalPage","27":"MyVehicleProfilePage","28":"MyVehiclesPage","29":"NewsArticlesPage","30":"NewsroomPage","31":"PayPlusPage","32":"PaySavingsPage","33":"PressReleaseLookup","34":"PressReleasePage","35":"PressReleasesPage","36":"PrivacyPolicies-Canada","37":"PrivacyPolicies-USA","38":"ProfilePage","39":"RedirectToFuelLogBook","40":"RegionSelectPage","41":"RegionalGasPrices","42":"SearchResultsPage","43":"ShopYourWayPage","44":"SocialSignup","45":"Station","46":"Terms","47":"TimelinePage","48":"UbiQuote","49":"Unknown","50":"UserEmailPreferencesPage","51":"VehicleRecallSearchPage","52":"VehicleRecallSearchResultsPage","53":"VisitorPreferencesPage","56":"vendors~LandingPageTemplate1","57":"vendors~ProfilePage","58":"vendors~ShopYourWayPage","59":"vendors~SocialSignup","60":"vendors~UserEmailPreferencesPage"}[chunkId]||chunkId) + "." + {"0":"fb88420d880e22975151","1":"cebb2287c794bb59fe50","2":"91f1a1b2f3730ef7801a","3":"763c9b7586880f29cf52","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"8ceca656f62e1af7b3a3","9":"342efe5a4b7af56e79fc","10":"93a4232998601f63e7a9","11":"c58cf5d3594d0d58c31a","12":"d143bb3b852ad0a46df8","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"00ed2f5003f200de73a1","16":"dc3cf72e8f0f3ae39af5","17":"1d45d19169c7d587d225","18":"e7736892f93831c1b23f","19":"91d21da6255913ef0a9a","20":"1158f66f642142097bf7","21":"63a855d83314bf103230","22":"b4187b6160d9dfdd91b9","23":"daf61312900505926464","24":"26bf602c8f2dfdc4cdf5","25":"ee662a3481c4cecd754e","26":"b23ea0f83ae905ffc01f","27":"5ed2c636f9cf8362adc0","28":"0773876e71ab526fe393","29":"3a9352477372010f7eba","30":"4a8b649490941bb51ca7","31":"dd423f881277c69d4954","32":"3c56ed758783b71f5796","33":"d143bb3b852ad0a46df8","34":"51a8ac1ba263cc66ef8d","35":"3a9352477372010f7eba","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"42444973b8c009046787","39":"d143bb3b852ad0a46df8","40":"f29b08e5ca60d37bc9e6","41":"b52c8d9630df5dcbc79a","42":"8d758d27d27b988a8b8b","43":"202a95cde222ade2c6b5","44":"31d6cfe0d16ae931b73c","45":"d47946859922204430a0","46":"31d6cfe0d16ae931b73c","47":"785b8f068343933b16a5","48":"4df9ecf1388141c18fa7","49":"d143bb3b852ad0a46df8","50":"9b4b93f562711aafa815","51":"1fcc23a1e171d320debf","52":"6a113da6822d2a0714e1","53":"4df64c0ffcea97b5bf77","56":"7e418866560a8ad73357","57":"7c01722d14ea4269d5ac","58":"f6b915c5202c79d5a3b5","59":"544a71a98ba8f2651e9f","60":"445e622955441584b061"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([220,55]);
 	// run deferred modules when ready
 	return checkDeferredModules();
